import { render, staticRenderFns } from "./Notebook.vue?vue&type=template&id=72873956&scoped=true&"
import script from "./Notebook.vue?vue&type=script&lang=js&"
export * from "./Notebook.vue?vue&type=script&lang=js&"
import style0 from "./Notebook.vue?vue&type=style&index=0&id=72873956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72873956",
  null
  
)

export default component.exports